// extracted by mini-css-extract-plugin
module.exports = {"container":"BinaryFileEditor_container__38VR4","mediaContainer":"BinaryFileEditor_mediaContainer__ghjmd","image":"BinaryFileEditor_image__2eyX5"};